import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-lucian-of-samosata',
  imports: [Link, RouterLink],
  templateUrl: './lucian-of-samosata.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lucian-of-samosata.scss',
})
export class LucianOfSamosata {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Lucian of Samosata`);
    this.dynamicTitle.description(`Lucian of Samosata is known for his works that mocked various aspects of ancient society, including religion.`);
  }
}
